module.exports = __webpack_public_path__ + "static/img/bottom_light.8b86f503.png";